import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import DummyLabelHelper from "./DummyLabel"
import Loader from "../Shared/Loader/loader";
import InnerLoader from "../Shared/Loader/InnerLoader";
import AttributeTypes from "./AttributeTypes";
import NoRecord from "../Display/NoRecord";
import Scrollable from "../Shared/Edit/Scrollable";
import { Button } from "@progress/kendo-react-buttons";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { withTranslation } from "react-i18next";
import { getAttributeTemplate, getAttributeTemplates } from "../../API/AttributeTemplate/AttributeTemplate";
import { createAttribute } from "../../API/Attribute/Attribute";
import { getGroupedData } from "./attributeGroupUtils";

function LoadMoreRow(props) {
    const { groupName, loadedCount, total, loading, onLoadMore, columnsCount } = props;
    const remaining = total != null ? total - loadedCount : null;
    const label = remaining != null
        ? `Load more (${remaining} remaining)`
        : "Load more";
    return (
        <tr className="k-master-row load-more-row">
            <td colSpan={columnsCount || 6} className="p-2">
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-primary text-decoration-none"
                    onClick={(e) => {
                        e.stopPropagation();
                        onLoadMore?.(groupName);
                    }}
                    disabled={loading}
                >
                    {loading ? "Loading..." : label}
                </button>
            </td>
        </tr>
    );
}

class SelectAttributeTemplate extends Component {

    DataTypes = AttributeTypes.Types;
    Icons = AttributeTypes.Icons;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            searchValue: "",
            AttributeTemplate: [],
            allAttributeTemplate: [],
            selectedItem: {},
            adding: false,
            creatingAttribute: false,
            hasGroups: false,
            expandedGroups: {},
            groupLoadState: {},
            loadingGroups: {}
        };
    }

    componentDidMount = async () => {
        this.getAttributeTemplate();
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }

        const { t } = this.props;

        return (
            <Dialog
                title={t("title")}
                onClose={this.closeAttributeDialog}
                width="50%"
                autoFocus
                height="70%"
                className="dialog"
            >
                {this.state.creatingAttribute && <OverlayLoader />}
                <div className="d-flex mb-2 mt-2 align-items-center padding-LR input-group">
                    {/* TODO: Support unicode inside placeholder */}
                    <input
                        className="form-control"
                        onChange={this.sortAttributeTemplate}
                        value={this.state.searchValue}
                        type="text"
                        placeholder={t("search_input_placeholder")}

                    />
                    {/* <a target="_blank" href={process.env.REACT_APP_DESIGNER_URL + "/" + this.props.organizatin.orgName + "/_Organisation/AttributeTemplate"} className="ms-3 text-link pt-2 text-nowrap" >
                        Manage Property Template
                    </a> */}
                </div>

                {this.state.allAttributeTemplate.length === 0 && (
                    <NoRecord message={t("no_record_message")} />
                )}
                {this.state.allAttributeTemplate.length !== 0 && (
                    <Scrollable>
                        <div className="grid-spacer">
                            {this.state.hasGroups ? (
                                <Grid
                                    className="no-alt"
                                    data={this.getGroupedGridData()}
                                    group={[{ field: "group" }]}
                                    expandField="expanded"
                                    groupable={false}
                                    onRowClick={this.SelectAttributeTemplate}
                                    scrollable={false}
                                    selectedField="selected"
                                    dataItemKey="_id"
                                    cellRender={this.groupHeaderCellRender}
                                    rowRender={(trElement, props) => {
                                        if (props.dataItem?.__loadMore) {
                                            const groupName = props.dataItem.group;
                                            const loadedCount = props.dataItem.__loadedCount ?? 0;
                                            const total = this.state.groupLoadState[groupName]?.total;
                                            return (
                                                <LoadMoreRow
                                                    groupName={groupName}
                                                    loadedCount={loadedCount}
                                                    total={total}
                                                    loading={this.state.loadingGroups[groupName]}
                                                    onLoadMore={this.loadMoreForGroup}
                                                    columnsCount={6}
                                                />
                                            );
                                        }
                                        return React.cloneElement(trElement, {
                                            className: props.dataItem?.selected ? "k-master-row k-state-selected" : "k-master-row"
                                        }, trElement.props.children);
                                    }}
                                >
                                    <Column field="indexId" title="#" width={40}
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td><span>{props.dataIndex !== undefined ? props.dataIndex + 1 : ""}</span></td>
                                        )}
                                    />
                                    <Column
                                        field="attributeName"
                                        title={t("grid.name_column_header")}
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td><span>{props.dataItem.attributeName}</span></td>
                                        )}
                                    />
                                    <Column
                                        field="attributeType"
                                        title={t("grid.type_column_header")}
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td>
                                                <i style={{ width: 15 }} className={`${this.Icons[props.dataItem.attributeType]} pe-1 text-center`}></i>
                                                {props.dataItem.typeText}
                                            </td>
                                        )}
                                    />
                                    <Column
                                        field="group"
                                        title={t("grid.group_column_header")}
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td>{props.dataItem.group === "(Ungrouped)" ? "—" : (props.dataItem.group || "—")}</td>
                                        )}
                                    />
                                    <Column
                                        field="description"
                                        title={t("grid.description_column_header")}
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td>{props.dataItem.description}</td>
                                        )}
                                    />
                                    <Column
                                        cell={(props) => (props.rowType === "groupHeader" || props.dataItem?.__loadMore) ? null : (
                                            <td className="text-end pointer">
                                                {(this.state.creatingAttribute && this.state.selectedItem._id === props.dataItem._id) ? (
                                                    <div className="d-inline-block float-end text-end">
                                                        <InnerLoader borderColor={"#0c850c"} />
                                                        <span className="me-4 text-success"></span>
                                                    </div>
                                                ) : this.state.creatingAttribute ? (
                                                    <button disabled={true} className="btn p-0 border-0 text-muted fw-bold">
                                                        <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={() => this.CreateAttribute(props.dataItem)}
                                                        disabled={this.shouldAddBeDisabledForAttribute(props.dataItem)}
                                                        className="btn p-0 border-0 t-primary fw-bold"
                                                    >
                                                        <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                    </button>
                                                )}
                                            </td>
                                        )}
                                    />
                                </Grid>
                            ) : (
                                <Grid
                                    className="no-alt"
                                    data={this.state.AttributeTemplate.map(
                                        (item, index) => ({
                                            ...item,
                                            selected: item._id === this.state.selectedItem._id,
                                            index,
                                        })
                                    )}
                                    onRowClick={this.SelectAttributeTemplate}
                                    selectedField="selected"
                                    dataItemKey="_id"
                                >
                                    <Column field="indexId" title="#" width={40}
                                        cell={(props) => (
                                            <td><span>{props.dataIndex !== undefined ? props.dataIndex + 1 : ""}</span></td>
                                        )}
                                    />
                                    <Column
                                        field="attributeName"
                                        title={t("grid.name_column_header")}
                                        cell={(props) => (
                                            <td><span>{props.dataItem.attributeName}</span></td>
                                        )}
                                    />
                                    <Column
                                        field="attributeType"
                                        title={t("grid.type_column_header")}
                                        cell={(props) => (
                                            <td>
                                                <i style={{ width: 15 }} className={`${this.Icons[props.dataItem.attributeType]} pe-1 text-center`}></i>
                                                {props.dataItem.typeText}
                                            </td>
                                        )}
                                    />
                                    <Column
                                        field="group"
                                        title={t("grid.group_column_header")}
                                        cell={(props) => (
                                            <td>{props.dataItem.group || "—"}</td>
                                        )}
                                    />
                                    <Column
                                        field="description"
                                        title={t("grid.description_column_header")}
                                    />
                                    <Column
                                        cell={(props) => (
                                            <td className="text-end pointer">
                                                {(this.state.creatingAttribute && this.state.selectedItem._id === props.dataItem._id) ? (
                                                    <div className="d-inline-block float-end text-end">
                                                        <InnerLoader borderColor={"#0c850c"} />
                                                        <span className="me-4 text-success"></span>
                                                    </div>
                                                ) : this.state.creatingAttribute ? (
                                                    <button disabled={true} className="btn p-0 border-0 text-muted fw-bold">
                                                        <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={() => this.CreateAttribute(props.dataItem)}
                                                        disabled={this.shouldAddBeDisabledForAttribute(props.dataItem)}
                                                        className="btn p-0 border-0 t-primary fw-bold"
                                                    >
                                                        <i className="mx-1 fa-solid fa-plus"></i>{t("buttons.add")}
                                                    </button>
                                                )}
                                            </td>
                                        )}
                                    />
                                </Grid>
                            )}
                        </div>
                    </Scrollable>
                )}


                <DialogActionsBar layout="end">
                    <div className="m-3">
                        <Button
                            onClick={this.closeAttributeDialog}
                            className="btn btn-secondary"
                        >
                            {t("buttons.cancel")}
                        </Button>
                    </div>
                </DialogActionsBar>
            </Dialog>
        );
    }

    getAttributeTemplate = async () => {
        const res = await getAttributeTemplates(this.props.organization._id);
        const rawItems = Array.isArray(res) ? res : (res.data || []);
        const enriched = rawItems.map((item) => this.setProperties({ ...item }));
        const results = enriched.sort((a, b) =>
            (a.attributeName || "").localeCompare(b.attributeName || "")
        );
        results.forEach((item, i) => {
            item.indexId = i + 1;
        });
        if (results.length > 0) {
            this.SelectAttributeTemplate(results[0]);
        }
        this.setState({
            AttributeTemplate: results,
            allAttributeTemplate: results,
            loading: false,
            hasGroups: this.computeHasGroups(results),
        });
    };

    setProperties = (dataItem) => {
        let properties = {};
        properties.attributeName = dataItem.LookupName;
        properties.attributeType = dataItem.lookupType;
        properties.attributeLabel = dataItem.LookupName;
        properties.tooltip = dataItem.LookupName;
        properties.typeText = this.DataTypes.find(
            (type) => type.value === properties.attributeType
        ).text;
        properties.readonly = false;
        properties.group = (dataItem.group ?? "").trim();
        properties.defaultValue = dataItem.lookupType === "Boolean" ? false : "";
        delete dataItem["lookupType"];
        delete dataItem["LookupName"];
        delete dataItem["createdDate"];
        delete dataItem["order"];
        delete dataItem["label"];
        delete dataItem["updatedDate"];
        return { ...dataItem, ...properties };
    };

    shouldAddBeDisabledForAttribute = (attribute) => {
        const isStateAttribute = attribute.attributeType === "State Field";
        const hasStateAttribute = this.props.allAttributes.findIndex(attribute => (
            attribute.attributeType === "State Field"
        )) > -1;
        return isStateAttribute && hasStateAttribute;
    }

    SelectAttributeTemplate = (dataItem) => {
        var data = {};

        if (dataItem["dataItem"]) {
            data = dataItem.dataItem;
        } else {
            data = dataItem;
        }
        if (!data._id || data.__loadMore || String(data._id).startsWith("__loadMore-")) return;
        this.setState({
            selectedItem: data,
        });
    };

    loadMoreForGroup = async (groupName) => {
        const { allAttributeTemplate } = this.state;
        const loadedCount = allAttributeTemplate.filter((item) => {
            const g = (item.group || "").trim();
            return (g || "(Ungrouped)") === groupName;
        }).length;

        this.setState({ loadingGroups: { ...this.state.loadingGroups, [groupName]: true } });
        try {
            const res = await getAttributeTemplates(this.props.organization._id, {
                group: groupName === "(Ungrouped)" ? "" : groupName,
                skip: loadedCount,
                take: 20
            });
            const newItems = Array.isArray(res) ? res : (res.data || []);
            const total = res.total;

            const enriched = newItems.map((item) => this.setProperties({ ...item }));
            const merged = [...allAttributeTemplate, ...enriched].sort((a, b) =>
                (a.attributeName || "").localeCompare(b.attributeName || "")
            );
            merged.forEach((item, i) => {
                item.indexId = i + 1;
            });

            const groupTotal = total != null
                ? total
                : (newItems.length < 20 ? loadedCount + newItems.length : undefined);

            let AttributeTemplate = merged;
            if (this.state.searchValue) {
                AttributeTemplate = merged.filter((attr) =>
                    (attr.attributeName || "").toLowerCase().includes(this.state.searchValue.trim().toLowerCase())
                );
            }

            this.setState({
                allAttributeTemplate: merged,
                AttributeTemplate,
                groupLoadState: groupTotal != null
                    ? { ...this.state.groupLoadState, [groupName]: { total: groupTotal } }
                    : this.state.groupLoadState,
                loadingGroups: { ...this.state.loadingGroups, [groupName]: false }
            });
        } catch (error) {
            console.error(error);
            this.setState({ loadingGroups: { ...this.state.loadingGroups, [groupName]: false } });
        }
    };

    gotoURl = (dataItem) => {
        this.SelectAttributeTemplate(dataItem);

        let url =
            process.env.REACT_APP_DESIGNER_URL +
            "/" +
            this.props.organization.orgName +
            "/_Organisation/AttributeTemplate/" +
            dataItem.sysName;

        window.open(url, "_blank");
    };

    closeAttributeDialog = () => {
        this.props.closeDialog(false);
    };

    getProducts = (sort) => {
        return orderBy(this.state.AttributeTemplate, sort);
    };

    sortAttributeTemplate = (e) => {
        let AttributeTemplate = this.state.allAttributeTemplate;

        if (e.target.value !== "") {
            AttributeTemplate = AttributeTemplate.filter((attr) => attr.attributeName.toLowerCase().includes(e.target.value.trim().toLowerCase()));
        }

        this.setState({
            AttributeTemplate: AttributeTemplate,
            searchValue: e.target.value,
            hasGroups: this.computeHasGroups(AttributeTemplate),
        });
    };

    computeHasGroups = (data) => {
        return (data || []).some((attr) => attr.group && attr.group.trim());
    };

    getGridDataForGrouping = () => {
        const { AttributeTemplate, selectedItem } = this.state;
        if (
            this._gridDataForGroupingCache &&
            this._gridDataForGroupingCacheDeps?.AttributeTemplate === AttributeTemplate &&
            this._gridDataForGroupingCacheDeps?.selectedItem === selectedItem
        ) {
            return this._gridDataForGroupingCache;
        }
        const result = AttributeTemplate.map((item, index) => ({
            ...item,
            group: item.group && item.group.trim() ? item.group : "(Ungrouped)",
            selected: item._id === selectedItem._id,
            index,
        }));
        this._gridDataForGroupingCacheDeps = { AttributeTemplate, selectedItem };
        this._gridDataForGroupingCache = result;
        return result;
    };

    getGroupedGridData = () => {
        const { expandedGroups, groupLoadState } = this.state;
        const gridData = this.getGridDataForGrouping();
        if (
            this._groupedGridDataCache &&
            this._groupedGridDataCacheDeps?.gridData === gridData &&
            this._groupedGridDataCacheDeps?.expandedGroups === expandedGroups &&
            this._groupedGridDataCacheDeps?.groupLoadState === groupLoadState
        ) {
            return this._groupedGridDataCache;
        }
        const result = getGroupedData(gridData, "group");
        if (result.data && result.data.length > 1) {
            result.data.forEach((group) => {
                const groupName = group.value || "(Ungrouped)";
                group.expanded = expandedGroups.hasOwnProperty(groupName)
                    ? expandedGroups[groupName]
                    : true;
                const loadedCount = (group.items || []).filter((i) => !i.__loadMore).length;
                const total = groupLoadState[groupName]?.total;
                const hasMore = total != null && loadedCount < total;
                if (hasMore && group.items && group.items.length > 0) {
                    group.items.push({
                        __loadMore: true,
                        group: groupName,
                        _id: `__loadMore-${groupName}`,
                        __loadedCount: loadedCount
                    });
                }
            });
        }
        this._groupedGridDataCacheDeps = { gridData, expandedGroups, groupLoadState };
        this._groupedGridDataCache = result;
        return result;
    };

    groupHeaderCellRender = (defaultRendering, props) => {
        if (props.rowType !== "groupHeader") {
            return defaultRendering;
        }
        const dataItem = props.dataItem;
        const groupName = dataItem.value || "(Ungrouped)";
        const isExpanded = dataItem.expanded !== false;
        return (
            <td
                key={props.id}
                colSpan={props.columnsCount}
                style={props.style}
                className="k-group-cell attribute-group-header-cell"
                role="gridcell"
            >
                <p className="k-reset d-flex align-items-center">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState((prev) => ({
                                expandedGroups: { ...prev.expandedGroups, [groupName]: !isExpanded }
                            }));
                            props.onChange?.({
                                dataItem: dataItem,
                                dataIndex: props.dataIndex,
                                syntheticEvent: e,
                                field: "expanded",
                                value: !isExpanded
                            });
                        }}
                        className={isExpanded ? "k-i-collapse k-icon me-2" : "k-i-expand k-icon me-2"}
                        aria-label={isExpanded ? "Collapse" : "Expand"}
                    />
                    <span className="fw-bold me-2">{groupName}</span>
                    {dataItem.items && (
                        <span className="badge bg-light text-dark me-2">
                            {dataItem.items.filter((i) => !i.__loadMore).length}
                        </span>
                    )}
                </p>
            </td>
        );
    };

    CreateAttribute = async (data) => {
        this.setState({
            adding: true,
            selectedItem: data,
            creatingAttribute: true
        })

        let dataItem = { ...data };

        const selectedTemplateId = dataItem._id;
        let latestAttributeTemplate = await getAttributeTemplate(dataItem._id);
        dataItem = this.setProperties(latestAttributeTemplate);

        let order = 10000000000

        if (this.props.allAttributes.length > 0) {
            order = parseInt(this.props.allAttributes[this.props.allAttributes.length - 1].order) + 10000000000;
        }
        let counter = 0;
        const initialName = dataItem.attributeName;
        let finalName = initialName;
        for (
            let attributeIndex = 0;
            attributeIndex < this.props.allAttributes.length;
            attributeIndex++
        ) {
            if (
                this.props.allAttributes[attributeIndex].attributeName ===
                finalName
            ) {
                ++counter;
                finalName = initialName + "(" + counter + ")";
            }
        }

        dataItem.attributeName = finalName;
        dataItem.attributeLabel = finalName;
        dataItem.required = this.props.data.length === 0;
        dataItem.readOnly = false;
        dataItem.tooltip = finalName;
        dataItem.order = order || 10000000000;
        dataItem.sysName = "attribute";
        // Track which attribute template this attribute was created from.
        dataItem.attributeTemplateId = dataItem._id || selectedTemplateId;
        delete dataItem["_id"];
        delete dataItem["typeText"];
        delete dataItem["indexId"];
        delete dataItem["cellFormatting"];

        if (
            dataItem.attributeType === "String"
        ) {
            dataItem.dummyLabel = DummyLabelHelper.getDummyLabel(dataItem.attributeLabel, dataItem.attributeType)
        } else if (
            dataItem.attributeType === "URL" ||
            dataItem.attributeType === "Email" ||
            dataItem.attributeType === "Multiline Text" ||
            dataItem.attributeType === "Html"
        ) {
            dataItem.dummyLabel = DummyLabelHelper.TypeMap.find(type => type.type === dataItem.attributeType).value
        } else if (dataItem.attributeType === "State Field") {
            dataItem.required = true;
            dataItem.setStatesRules = false;
        } else if (dataItem.attributeType === "Tree Dropdown") {
            dataItem.treeDropdown = JSON.stringify(dataItem.treeDropdown);
        }

        const attributeWithCellFormatting = ["DateTime", "Tags", "Picklist String", "State Field", "Number"];
        if (attributeWithCellFormatting.includes(dataItem.attributeType)) {
            dataItem.cellFormatting = JSON.stringify({ ifStatement: [], elseStatement: [] });
        }

        const attribute = await createAttribute(this.props.entityId, {
            subscriptionId: this.props.organization.subscriptionId,
            projectId: this.props.project._id,
            properties: dataItem,
        });

        if (attribute.status && attribute.status === "Failure") {
            this.props.closeDialog(true)
        } else {
            attribute.typeText = this.DataTypes.find((type) => type.value === dataItem.attributeType).text;
            attribute.required = attribute.required === true;
            attribute.readOnly = attribute.readOnly === true;
            attribute.multiSelect = attribute.multiSelect === true;
            attribute.indexId = this.props.data.length + 1;
            this.setState({
                adding: false,
                creatingAttribute: false
            });
            this.props.onSelect(attribute, false);
        }
    };
}

export default withTranslation(["attribute/select_attribute_template_dialog"])(
    SelectAttributeTemplate
);
